import FindAFacility from ".";

export default function FindAFacilityExamples() {
  return <FindAFacility onBackButton={() => console.log("onBackButton")} />;
}
